module.exports = __webpack_public_path__ + "static/media/mesonry-cat2-lg-6.782a019f.jpg";